export let data = {
  title: "UGD",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "UGD Baru",
      link: "/ugd/daftar",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let tabs = [
  { title: "TERDAFTAR", filter: "DIJADWALKAN", active: true },
  {
    title: "ANTRIAN DOKTER",
    filter: "ANTRIAN DOKTER"
  },
  {
    title: "SEDANG DIPERIKSA",
    filter: "SEDANG DIPERIKSA"
  },
  {
    title: "SELESAI DIPERIKSA",
    filter: "SELESAI DIPERIKSA"
  },
  {
    title: "MENUNGGU PEMBAYARAN",
    filter: "MENUNGGU PEMBAYARAN"
  },
  { title: "SELESAI", filter: "SELESAI" },
  { title: "DIBATALKAN", filter: "DIBATALKAN" },
];
export let references = [
  {
    value: "SEMUA",
    label: "Semua"
  },
  {
    value: "1",
    label: "Dengan Rujukan"
  },
  {
    value: "0",
    label: "Tanpa Rujukan"
  }
];
export let doctors = [

];
export let payments = [
  {
    value: "1",
    label: "Umum"
  },
  {
    value: "2",
    label: "BPJS"
  },
  {
    value: "3",
    label: "Lainnya"
  }
];
export let sorts = [
  {
    value: "asc",
    label: "No Rawat"
  },
  {
    value: "desc",
    label: "Terbaru"
  }
];
export let sortsDoc = [
  {
    value: "asc",
    label: "No Antrian"
  },
  {
    value: "desc",
    label: "Terbaru"
  }
];
export let filters = {
  colnum: "",
  columns: [
    {
      label: "dari tanggal",
      type: "date",
      placeholder: "Tanggal periksa",
      name: "created_from",
      value: new Date(),
      mandatory: true,
      colwidth: 3,
      id: "filterDateStart"
    },
    {
      label: "sampai tanggal",
      type: "date",
      placeholder: "Tanggal periksa",
      name: "created_to",
      value: new Date(),
      mandatory: true,
      colwidth: 3,
      id: "filterDateEnd"
    },
    // {
    //   label: "Rujukan",
    //   type: "select",
    //   placeholder: "Semua",
    //   value: "",
    //   name: "dirujuk",
    //   mandatory: true,
    //   options: references,
    //   colwidth: 3,
    //   id: "filterReference"
    // },
    {
      label: "Dokter",
      type: "select",
      placeholder: "Semua",
      value: "",
      name: "id_dokter",
      mandatory: true,
      options: doctors,
      colwidth: 6,
      id: "filterDoctor"
    }
  ]
};
export let filtersDoc = {
  colnum: "",
  columns: [
    {
      label: "dari tanggal",
      type: "date",
      placeholder: "Tanggal periksa",
      name: "created_from",
      value: new Date(),
      mandatory: true,
      colwidth: 3,
      id: "filterDateStart"
    },
    {
      label: "sampai tanggal",
      type: "date",
      placeholder: "Tanggal periksa",
      name: "created_to",
      value: new Date(),
      mandatory: true,
      colwidth: 3,
      id: "filterDateEnd"
    },
    // {
    //   label: "Rujukan",
    //   type: "select",
    //   placeholder: "Semua",
    //   value: "",
    //   name: "dirujuk",
    //   mandatory: true,
    //   options: references,
    //   colwidth: 3,
    //   id: "filterReference"
    // },
    {
      label: "Dokter",
      type: "select",
      placeholder: "Semua",
      value: "",
      name: "id_dokter",
      mandatory: true,
      readonly:true,
      options: doctors,
      colwidth: 6,
      id: "filterDoctor"
    }
  ]
};
export let sort = {
  colnum: 1,
  columns: [
    {
      label: "Sort By",
      type: "select",
      placeholder: "",
      name:"orderBy",
      value: "desc",
      mandatory: true,
      options: sorts
    }
  ]
};
export let sortDoc = {
  colnum: 1,
  columns: [
    {
      label: "Sort By",
      type: "select",
      placeholder: "",
      name:"orderBy",
      value: "asc",
      mandatory: true,
      options: sortsDoc,
      readonly:true
    }
  ]
};
